import { render, staticRenderFns } from "./invadjust.vue?vue&type=template&id=ca4376a4"
import script from "./invadjust.vue?vue&type=script&lang=js"
export * from "./invadjust.vue?vue&type=script&lang=js"
import style0 from "./invadjust.vue?vue&type=style&index=0&id=ca4376a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports